import { RecorderAce } from "./src/RecorderAce";
import { Services } from "./src/services/Services";
import { AppSettings } from "./src/settings/AppSettings";

export class Main {
	private _app:RecorderAce;
	
	constructor(){
		this._init();
	}
	
	private _init():void{
		AppSettings.init();
		
		let apiUrl = AppSettings.getJSParam("apiUrl") as string;
		Services.rootApiPath = apiUrl;
		Services.recorderAceApiPath = (apiUrl + "RecorderAce/");
		
		this._cleanUrl();
		
		//launch app
		this._app = new RecorderAce();
	}
	
	private _cleanUrl():void {
		let url = window.location.toString();
		//first check for song ID with old URL string with just #id
		let songNum:string;
		let regEx = /#\d+/;
		let matches = url.match(regEx);
		if (matches != null){
			songNum = matches[0].substring(1);
		}

		//now check for song ID with new URL string with #!id
		regEx = /#!\d+/;
		matches = url.match(regEx);
		if (matches != null){
			songNum = matches[0].substring(2);
		}
		
		if (songNum != null){
			window.history.replaceState({'url': ''}, "menuView", 
				`./?id=${songNum}`);
		}
		else if (url.endsWith("#")){
			window.history.replaceState({'url': ''}, "menuView", "./");
		}
	}
}

new Main();